import React, { useState, useEffect } from 'react'
import { db } from '../firebase-config'
import { deleteDoc, doc } from 'firebase/firestore'
import { Button } from './Button'
import styles from './Entry.module.css'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export const Entry = ({ entry, user }) => {
    const [userIsAuthor, setUserIsAuthor] = useState(false)

    useEffect(() => {
        if (user) {
            if (user.email === entry.author) {
                setUserIsAuthor(true)
            }
        }
    }, [])

    return (
        <div className={styles.entryContainer}>
            <h3>{entry.title}</h3>
            <p>{entry.content}</p>
            <p>{entry.contact}</p>
            {userIsAuthor && <Button onClick={() => {
                try {
                    deleteDoc(doc(db, 'news', entry.id))
                        .then(() => window.location.href = '/news')

                } catch (error) {
                    toast.error('Leider ist beim Löschen ein Fehler aufgetreten. Bitte versuche Sie es ',
                        {
                            position: 'top-center',
                        })
                }

            }}>Beitrag löschen</Button>}
        </div>
    )
}
